import { render, staticRenderFns } from "./ErrorExpired.vue?vue&type=template&id=fe7f21ba&scoped=true&"
import script from "./ErrorExpired.vue?vue&type=script&lang=js&"
export * from "./ErrorExpired.vue?vue&type=script&lang=js&"
import style0 from "./ErrorExpired.vue?vue&type=style&index=0&id=fe7f21ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe7f21ba",
  null
  
)

export default component.exports